import { render, staticRenderFns } from "./ParcelRepresentativeDeclarantSection.vue?vue&type=template&id=24711f94&scoped=true&"
import script from "./ParcelRepresentativeDeclarantSection.vue?vue&type=script&lang=js&"
export * from "./ParcelRepresentativeDeclarantSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelRepresentativeDeclarantSection.vue?vue&type=style&index=0&id=24711f94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24711f94",
  null
  
)

export default component.exports